import { render, staticRenderFns } from "./appFunctionSwitchManageList.vue?vue&type=template&id=404a1938&scoped=true"
import script from "./appFunctionSwitchManageList.vue?vue&type=script&lang=js"
export * from "./appFunctionSwitchManageList.vue?vue&type=script&lang=js"
import style0 from "./appFunctionSwitchManageList.vue?vue&type=style&index=0&id=404a1938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a1938",
  null
  
)

export default component.exports